export default __webpack_public_path__ + "static/media/DoubleCoinGrey.3c6069d0.svg";